module.exports = __webpack_public_path__ + "img/EAD8D6_B59A97_CCB4B0_C9ABAB-256px.b5abc395.png";